import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import Vue from 'vue'

// initial state
const state = {
  wirtschaftsplane: [],
  loaded: false,
  loading: false,
  error: null
}

// getters
const getters = {
  wirtschaftsplane (state) {
    return state.wirtschaftsplane
  },
  wirtschaftsplan: (state) => (id) => {
    return state.wirtschaftsplane.find(wirtschaftsplan => wirtschaftsplan.id === id)
  },
  loading (state) {
    return state.loading
  },
  error (state) {
    return state.error
  }
}

// actions
const actions = {
  loadWirtschaftsplane ({commit}) {
    commit('setLoading', true)
    console.log('Wirtschaftsplan laden...')
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('wirtschaftsplane').orderBy('datum', 'desc').get()
    .then(snapshot => {
      const wirtschaftsplane = []
      snapshot.forEach(doc => {
        wirtschaftsplane.push({
          ...doc.data(),
          id: doc.id
        })
        commit('setLoadedWirtschaftsplane', wirtschaftsplane)
        commit('setLoading', false)
        commit('setLoaded', true)
      })
    })
    .catch(
      (error) => {
        console.log(error)
        commit('setLoading', false)
      }
    )
  },
  createWirtschaftsplan ({commit, getters}, payload) {
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('wirtschaftsplane').add(payload)
      .then(key => {
        commit('createWirtschaftsplan', {
          ...payload,
          id: key.id
        })
      })
      .catch((error) => {
        console.log(error)
      })
  // Reach out to firebase and store it
  },
  deleteWirtschaftsplanData ({commit}, payload) {
    commit('setLoading', true)
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('wirtschaftsplane').doc(payload).delete()
    .then(() => {
      commit('setLoading', false)
      commit('deleteWirtschaftsplan', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
    commit('setLoading', false)
  },
  updateWirtschaftsplanData ({commit}, payload) {
    commit('setLoading', true)
    const updateObj = {}
    Object.keys(payload).forEach(key => {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key]
      }
    })
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('wirtschaftsplane').doc(payload.id).update(updateObj)
    .then(() => {
      commit('setLoading', false)
      commit('updateWirtschaftsplan', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
  }
}

// mutations
const mutations = {
  setLoadedWirtschaftsplane (state, payload) {
    state.wirtschaftsplane = payload
  },
  createWirtschaftsplan (state, payload) {
    state.wirtschaftsplane.push(payload)
  },
  setLoaded (state, payload) {
    state.loaded = payload
  },
  updateWirtschaftsplan (state, payload) {
    const wirtschaftsplan = state.wirtschaftsplane.find(wirtschaftsplan => {
      return wirtschaftsplan.id === payload.id
    })
    Object.keys(payload).forEach(key => {
      if (payload[key]) {
        wirtschaftsplan[key] = payload[key]
      }
    })
  },
  deleteWirtschaftsplan (state, payload) {
    let array = state.wirtschaftsplane
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1)
      }
    }
    state.wirtschaftsplane = array
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setError (state, payload) {
    state.error = payload
  },
  clearError (state) {
    state.error = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/wirtschaftsplane_alt.js